import { create } from 'zustand';
import type { FirmwareUploadState } from '../types';

interface BootloaderState {
  isInBootloader: boolean;
  bootloaderVersion: string | null;
  programmingProgress: number;
  lastBootloaderMessageTime: number | null;
}

interface FirmwareStore extends FirmwareUploadState, BootloaderState {
  setFilePath: (path: string) => void;
  setFileName: (name: string) => void;
  setProgress: (progress: number) => void;
  setStatus: (status: string) => void;
  setIsUploading: (uploading: boolean) => void;
  setBootloaderState: (version: string, progress: number) => void;
  clearBootloaderState: () => void;
  reset: () => void;
}

const initialBootloaderState: BootloaderState = {
  isInBootloader: false,
  bootloaderVersion: null,
  programmingProgress: 0,
  lastBootloaderMessageTime: null,
};

const initialState: FirmwareUploadState & BootloaderState = {
  filePath: '',
  fileName: '',
  progress: 0,
  status: 'No transfer in progress',
  isUploading: false,
  ...initialBootloaderState,
};

export const useFirmwareStore = create<FirmwareStore>((set) => ({
  ...initialState,

  setFilePath: (path) => set({ filePath: path }),

  setFileName: (name) => set({ fileName: name }),

  setProgress: (progress) => set({ progress }),

  setStatus: (status) => set({ status }),

  setIsUploading: (uploading) => set({ isUploading: uploading }),

  setBootloaderState: (version, progress) => set({
    isInBootloader: true,
    bootloaderVersion: version,
    programmingProgress: progress,
    lastBootloaderMessageTime: Date.now(),
  }),

  clearBootloaderState: () => set(initialBootloaderState),

  reset: () => set(initialState),
}));
